namespace TabAurous.Finance {
    export interface ServiceOutwardDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        LedgerId?: number;
        LedgerName?: string;
        ServiceId?: number;
        ServiceCode?: string;
        TaxCode?: string;
        CategoryId?: number;
        Amount?: number;
    }

    export namespace ServiceOutwardDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Finance.ServiceOutwardDetails';
        export const deletePermission = 'Finance:ServiceOutward:Delete';
        export const insertPermission = 'Finance:ServiceOutward:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:ServiceOutward:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            ServiceId = "ServiceId",
            ServiceCode = "ServiceCode",
            TaxCode = "TaxCode",
            CategoryId = "CategoryId",
            Amount = "Amount"
        }
    }
}
